import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { Location } from 'history';

import { QueryParamKeys } from 'scenes/common/types';

import {
  CoverTypeQueryParam,
  DefaultCoverType,
  MotorCoverType,
} from '../types';
import { mapDefaultCoverOption } from '../actions';

const coverTypeQueryParam = new Map([
  [MotorCoverType.Comprehensive, CoverTypeQueryParam.COMP],
  [MotorCoverType.ThirdPartyFireAndTheft, CoverTypeQueryParam.TPFT],
  [MotorCoverType.ThirdPartyPropertyDamage, CoverTypeQueryParam.TPPD],
]);

const getCoverTypeQueryParam = (location: Location) => {
  const ctype = new URLSearchParams(location.search).get(QueryParamKeys.ctype);

  return Object.values(CoverTypeQueryParam).find((opt) => opt === ctype);
};

export const useCoverTypeParam = (
  onSetDefaultCoverOption: (defaultCoverOptions: DefaultCoverType) => void
): {
  coverTypeFromUrl: CoverTypeQueryParam | undefined;
  resetDefaultCoverType: (arg: MotorCoverType) => void;
} => {
  const [coverTypeFromUrl, setDefaultCoverType] = useState(
    getCoverTypeQueryParam(useLocation())
  );

  useEffect(() => {
    if (coverTypeFromUrl) {
      const coverOption = mapDefaultCoverOption(coverTypeFromUrl);
      if (coverOption) {
        onSetDefaultCoverOption(coverOption);
      }
    }
  }, [onSetDefaultCoverOption, coverTypeFromUrl]);

  const resetDefaultCoverType = (newCoverType: MotorCoverType) => {
    const updateCoverParam = coverTypeQueryParam.get(newCoverType);
    setDefaultCoverType(updateCoverParam);
    const coverOption = mapDefaultCoverOption(updateCoverParam);
    if (coverOption) {
      onSetDefaultCoverOption(coverOption);
    }
  };

  return { coverTypeFromUrl, resetDefaultCoverType };
};
